<template>
  <v-layout justify-center>
    <v-speed-dial
      fab
      fixed
      v-model="fab"
      :bottom="true"
      :right="true"
      direction="top"
      :open-on-hover="false"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark large fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-filter-variant</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark large color="green" @click.stop="filterDialog = true">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn fab dark large color="primary" class="mb-2" @click="openNewKeyDialog()">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-speed-dial>

    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field v-model="editedItem.description" clearable label="Descrição"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="editedItem.value"
                    :rules="[rules.required]"
                    append-icon="mdi-refresh"
                    readonly
                    @click:append="generateNewKey()"
                    label="Chave"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-if="editedIndex == -1"
                    v-model="editedItem.hardwareId"
                    disabled
                    label="Id Hardware"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="editedItem.hardwareId"
                    clearable
                    label="Id Hardware"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-dialog
                    ref="dialog1"
                    v-model="dialogStartDate"
                    :return-value.sync="editedItem.startDate"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editedItem.startDate"
                        label="Data Inicio"
                        prepend-icon="event"
                        readonly
                        :rules="[rules.required]"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :max="editedItem.endDate"
                      locale="pt-pt"
                      v-model="editedItem.startDate"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogStartDate = false">Cancel</v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog1.save(editedItem.startDate)"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-dialog
                    ref="dialog2"
                    v-model="dialogEndDate"
                    :return-value.sync="editedItem.endDate"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editedItem.endDate"
                        label="Data Fim"
                        prepend-icon="event"
                        :rules="[rules.required]"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :min="editedItem.startDate"
                      locale="pt-pt"
                      v-model="editedItem.endDate"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogEndDate = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.dialog2.save(editedItem.endDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-btn
                    class="ma-2"
                    :disabled="!editedItem.startDate"
                    outlined
                    color="indigo"
                    @click="addTime(1)"
                  >+1 mês</v-btn>
                  <v-btn
                    class="ma-2"
                    :disabled="!editedItem.startDate"
                    outlined
                    color="indigo"
                    @click="addTime(6)"
                  >+6 meses</v-btn>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-text-field
                    v-if="phone"
                    v-model="selectedApp"
                    label="Aplicação"
                    :rules="[rules.required]"
                    readonly
                    @click="$refs.appPopUp.start()"
                  ></v-text-field>
                  <v-autocomplete
                    v-else
                    v-model="editedItem.ApplicationId"
                    :items="apps"
                    item-text="name"
                    item-value="id"
                    label="Aplicação"
                    required
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-if="phone"
                    v-model="selectedClient"
                    label="Cliente"
                    :rules="[rules.required]"
                    readonly
                    @click="$refs.cliPopUp.start()"
                  ></v-text-field>

                  <v-autocomplete
                    v-else
                    v-model="editedItem.ClientId"
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    label="Cliente"
                    required
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text :disabled="savingInfo" @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text :loading="savingInfo" @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-flex xs12 sm12 md11>
      <v-data-table
        v-infinite-scroll="getItems"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="10"
        :headers="headers"
        :items="items"
        :loading="loading"
        hide-default-footer
        :items-per-page.sync="items.length + 10"
        class="elevation-1"
      >
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template v-slot:item.discontinued="{ item }">
          <v-icon v-if="item.discontinued" color="green darken-2">done</v-icon>
          <v-icon v-else color="red darken-2">clear</v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <td class="justify-center layout px-0">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon class="mx-0" @click="editItem(item)">
                  <v-icon v-on="on" color="green">edit</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon class="mx-0" @click="deleteItem(item)">
                  <v-icon v-on="on" color="pink">delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>

      <v-dialog v-model="filterDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Filtros :</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="Descrição" clearable v-model="description"></v-text-field>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-text-field
                    v-if="phone"
                    v-model="selectedApp"
                    label="Aplicação"
                    clearable
                    readonly
                    @click="$refs.appPopUp.start()"
                  ></v-text-field>
                  <v-autocomplete
                    v-else
                    v-model="editedItem.ApplicationId"
                    :items="apps"
                    item-text="name"
                    item-value="id"
                    label="Aplicação"
                    clearable
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-if="phone"
                    v-model="selectedClient"
                    label="Cliente"
                    readonly
                    clearable
                    @click="$refs.cliPopUp.start()"
                  ></v-text-field>

                  <v-autocomplete
                    v-else
                    v-model="editedItem.ClientId"
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    label="Cliente"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="filterDialog = false">Fechar</v-btn>
            <v-btn color="blue darken-1" text @click="filter()">Procurar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <pop-up-selector
        ref="cliPopUp"
        :itemList="clients"
        :id="'id'"
        :title="'Clientes'"
        :label="'Clientes'"
        :description="'name'"
        :fullReturn="true"
        @selection="changeClient"
      />

      <pop-up-selector
        ref="appPopUp"
        :itemList="apps"
        :id="'id'"
        :title="'Aplicações'"
        :label="'Aplicações'"
        :description="'name'"
        :fullReturn="true"
        @selection="changeApp"
      />
    </v-flex>
    <v-overlay :value="overlay"></v-overlay>
  </v-layout>
</template>

<script>
import infiniteScroll from "vue-infinite-scroll";
import moment from "moment";
import ServiceKeys from "@/services/ServiceKeys";
import ServiceClients from "@/services/ServiceClients";
import ServiceApps from "@/services/ServiceApps";
import PopUpSelector from "@/components/common/PopUpSelector";
import { isMobile } from "@/components/common/Utils";
import _ from "lodash";

export default {
  name: "Keys-List",
  directives: {
    infiniteScroll
  },
  components: {
    PopUpSelector
  },
  data: () => ({
    phone: false,
    dialogStartDate: false,
    dialogEndDate: false,
    valid: true,
    overlay: false,
    filterDialog: false,
    dialog: false,
    fab: false,
    page: 1,
    headers: [
      { text: "Chave", value: "value" },
      { text: "Id Hardware", value: "hardwareId" },
      { text: "Descrição", value: "description" },
      { text: "Data Inicio", value: "startDate" },
      { text: "Data Fim", value: "endDate" },
      { text: "Actions", value: "action", sortable: false, align: "center" }
    ],
    items: [],
    apps: [],
    clients: [],
    busy: false,
    loading: true,
    savingInfo: false,
    editedIndex: -1,
    description: null,
    clientId: null,
    appId: null,
    editedItem: {
      description: "",
      hardwareId: "",
      value: "",
      startDate: null,
      endDate: null,
      ApplicationId: 1,
      ClientId: 1,
      id: null
    },
    defaultItem: {
      description: "",
      hardwareId: "",
      value: "",
      startDate: null,
      endDate: null,
      ApplicationId: null,
      ClientId: null,
      id: null
    },
    selectedClient: "",
    selectedApp: "",
    rules: {
      required: value => !!value || "Campo Obrigatório."
    }
  }),

  methods: {
    addTime(months) {
      let currentDate;
      if (this.editedItem.endDate) {
        currentDate = moment(this.editedItem.endDate);
      } else {
        currentDate = moment(this.editedItem.startDate);
      }
      this.editedItem.endDate = moment(currentDate)
        .add(months, "M")
        .format("YYYY-MM-DD");
    },
    openNewKeyDialog() {
      let today = new Date();

      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");

      this.editedItem.startDate = today.getFullYear() + "-" + mm + "-" + dd;

      this.generateNewKey();

      this.dialog = true;
    },
    generateNewKey() {
      this.editedItem.value = "";
      var characters =
        "ABCDEFGHJKLMNOPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 12; i++) {
        this.editedItem.value += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }

      this.editedItem.value = [
        this.editedItem.value.slice(0, 4),
        "-",
        this.editedItem.value.slice(4)
      ].join("");
      this.editedItem.value = [
        this.editedItem.value.slice(0, 9),
        "-",
        this.editedItem.value.slice(9)
      ].join("");
    },
    filter() {
      this.items = [];
      this.page = 1;

      this.clientId = this.editedItem.ClientId;
      this.appId = this.editedItem.ApplicationId;

      this.getItems();
    },
    async getItems() {
      this.busy = true;
      this.loading = true;
      const response = await ServiceKeys.list(
        this.description,
        this.page,
        this.clientId,
        this.appId
      );

      this.items = this.items.concat(response.data);

      this.page++;
      this.busy = false;
      if (response.data.length == 0) {
        this.busy = true;
      }
      this.loading = false;
    },
    changeClient(client) {
      this.selectedClient = client.name;
      this.editedItem.ClientId = client.id;
    },
    changeApp(app) {
      this.selectedApp = app.name;
      this.editedItem.ApplicationId = app.id;
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);

      this.editedItem = Object.assign({}, item);

      if (this.phone) {
        let result = _.filter(this.clients, item => {
          return item.id === this.editedItem.ClientId;
        });
        this.selectedClient = result[0].name;

        result = _.filter(this.apps, item => {
          return item.id === this.editedItem.ApplicationId;
        });
        this.selectedApp = result[0].name;
      }

      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async deleteItem(item) {
      try {
        if (confirm("Confirma a eliminação deste elemento?")) {
          this.overlay = true;
          await ServiceKeys.delete(item.id);
          let index = this.items.indexOf(item);

          if (index != -1) {
            this.items.splice(index, 1);

            this.$store.dispatch("setSnackbar", {});
          }
          this.overlay = false;
        }
      } catch (error) {
        this.$store.dispatch("setSnackbar", {
          color: "error",
          text: error
        });
        this.overlay = false;
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.savingInfo = true;

        try {
          const response = await ServiceKeys.addUpdate(this.editedItem);
          if (this.editedIndex > -1) {
            Object.assign(this.items[this.editedIndex], response.data);
          } else {
            this.items.push(response.data);
            this.editedItem.id = response.data.id;
            this.editedIndex = this.items.length - 1;
          }

          this.savingInfo = false;
          this.$store.dispatch("setSnackbar", {});
        } catch (error) {
          this.$store.dispatch("setSnackbar", {
            color: "error",
            text: error.message
          });
          this.savingInfo = false;
        }
      }
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nova Chave" : "Editar Chave";
    }
  },
  async mounted() {
    try {
      this.overlay = true;

      this.phone = isMobile();

      let run = true;
      let page = 1;
      let response;
      while (run) {
        response = await ServiceApps.list(null, page);

        if (response.data.length == 0) {
          break;
        }

        this.apps = this.apps.concat(response.data);

        page++;
      }

      run = true;
      page = 1;
      while (run) {
        response = await ServiceClients.list(null, page, null);
        if (response.data.length == 0) {
          break;
        }

        this.clients = this.clients.concat(response.data);

        page++;
      }

      this.overlay = false;
    } catch (error) {
      this.$store.dispatch("setSnackbar", {
        color: "error",
        text: error.message
      });
      this.overlay = false;
    }
  }
};
</script>
